// export const api = "http://localhost:3001";
// export const endpoint = "http://localhost:3000";
// export const api = "https://app-fooder.herokuapp.com";
// export const api = 'https://fooder-backend-0d1i.onrender.com';
export const api = "https://fooder-backend-ar0b.onrender.com";
export const endpoint = "https://fooderweb.netlify.app";
